/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class DeployOverviewRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  async beforeModel() {
    await this.finStandaloneService.initialize();
    await this.finStandaloneService.intercomMessengerConfig.ruleset.promise;
  }
}
